import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/anealing_lehr.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/automatic_inspection.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/ccp.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/forming_machine.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/furness_control.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/is-machine.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/mould_workshop1.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/polari.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/quality_lab.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/sheet-glass.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/infrastructure/top-load.jpg");
;
import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/public/assets/product-process.jpg");
